import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { Bell, X } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ReminderBadge } from "web_myplann/Reminders/Components/ReminderBadge";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { resolveReminderBadge } from "web_myplann/Reminders/Utils/reminderBadge";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

type Props = {
	reminder: Reminder;
	onTap: () => void;
	onRemove: () => void;
	id?: string;
};

export const ReminderListRow = ({ reminder, onTap, onRemove, id }: Props) => {
	const { t } = useResource();
	const theme = useTheme();

	const badge = resolveReminderBadge(reminder);

	return (
		<Stack
			id={id}
			direction="row"
			alignItems="center"
			gap={1.2}
			onClick={onTap}
			sx={{ cursor: "pointer" }}
		>
			<Bell size={20} color={theme.palette.purple.main} />

			<Stack flex={1} minWidth={0}>
				<Typography variant="bodyStrong" color={theme.palette.grey[900]}>
					{reminder.name}
				</Typography>
				<Typography variant="hint" color={theme.palette.grey[500]}>
					{t(Resources.Reminders.Row.subtitle, {
						date: dateFormatter(reminder.date),
						recurrence: t(Resources.Reminders.Recurrence[reminder.recurrence]),
					})}
				</Typography>
				{reminder.snoozedUntil && (
					<Typography variant="hint" color={theme.palette.grey[500]}>
						{t(Resources.Reminders.Badge.snoozedUntil, {
							date: dateFormatter(reminder.snoozedUntil),
						})}
					</Typography>
				)}
			</Stack>

			<ReminderBadge variant={badge} />

			<IconButton
				onClick={(e) => {
					e.stopPropagation();
					onRemove();
				}}
				sx={{ bgcolor: theme.palette.grey[200] }}
			>
				<X size={16} color={theme.palette.grey[600]} />
			</IconButton>
		</Stack>
	);
};
